// © 2026 AttainIP Engineering
/**
 * Ad Platform Configuration
 *
 * Google Ads + LinkedIn conversion IDs. Same ad accounts as the
 * marketing site (precision-ip) so conversions attribute correctly.
 */

// Google Analytics 4
export const GA4_MEASUREMENT_ID = 'G-BLH7653ZVT';

// Google Ads
export const GOOGLE_ADS_ID = 'AW-17824014386';
export const GOOGLE_ADS_SIGNUP_LABEL = 'DI5kCOKjxfsbELLAk7NC';
export const GOOGLE_ADS_FIRST_VALUE_LABEL = 'xnJfCISoxfsbELLAk7NC';
export const GOOGLE_ADS_PURCHASE_LABEL = 'lmIACOWjxfsbELLAk7NC';

// LinkedIn Insight Tag
export const LINKEDIN_PARTNER_ID = '9294953';
export const LINKEDIN_SIGNUP_CONVERSION_ID = 25746553;
export const LINKEDIN_FIRST_VALUE_CONVERSION_ID = 26380505;
export const LINKEDIN_PURCHASE_CONVERSION_ID = 25746561;
